// tslint:disable: object-literal-sort-keys

import { Popover, PopoverInteractionKind } from '@blueprintjs/core';
import { IWidgetProps } from 'decorator-form';
import * as React from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import reactCSS from 'reactcss';

export default class ColorPickerWidget extends React.Component<IWidgetProps<string>, any> {

	public constructor(props: IWidgetProps<string>) {
		super(props);
	}

	private fromRgbaString(rgb: string = "rgba(0, 0, 0, 1"): ColorResult {
		const c = rgb.substring(5, rgb.length - 1)
			.replace(/ /g, '')
			.split(',');

		return {rgb: {r: c[0], g: c[1], b: c[2], a: c[3]}} as any;
	}

	private toRgbaString(color: ColorResult): string {
		return `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
	}

	private handleChange = (color: ColorResult) => {
		this.props.onChange(this.toRgbaString(color));
	}

	// tslint:disable-next-line:member-ordering
	public render() {
		const styles = reactCSS({
			default: {
				color: {
					width: '36px',
					height: '20px',
					borderRadius: '2px',
					background: this.props.value,
				},
				swatch: {
					padding: '5px',
					background: '#fff',
					borderRadius: '1px',
					boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
					display: 'inline-block',
					cursor: 'pointer',
				}
			},
		});

		return (
			<Popover interactionKind={PopoverInteractionKind.CLICK}>
				<div style={styles.swatch}>
					<div style={styles.color} />
				</div>
				<SketchPicker color={this.fromRgbaString(this.props.value).rgb} onChangeComplete={this.handleChange} />
			</Popover>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/ColorPickerWidget.tsx